import { inject, observer } from 'mobx-react';
import React from 'react';
// Import styles
import styles from './style.scss';

/**
 * AppTitle component, render only
 */
const AppTitle = inject('ViewStore')(observer(({ ViewStore }) => (
  <h1 className={styles.title} >
    {ViewStore.get('video')}
  </h1 >
)));

export default AppTitle;



// WEBPACK FOOTER //
// ./src/components/AppHeader/Title/index.js